// write by cursor
// 生成时间: 2025-07-29 16:45:55
// 简单的错误处理链实现

import { ErrorHandler, ApiRequestConfig } from '../types/request';

/**
 * 简单的错误处理链 - write by cursor
 */
export class SimpleErrorChain {
  private handlers: ErrorHandler[] = [];

  /**
   * 添加错误处理器 - write by cursor
   */
  use(handler: ErrorHandler): this {
    this.handlers.push(handler);
    return this;
  }

  /**
   * 执行错误处理链 - write by cursor
   */
  async handle(error: any, config?: ApiRequestConfig): Promise<boolean> {
    for (const handler of this.handlers) {
      try {
        const handled = await handler(error, config);
        if (handled) {
          return true; // 错误已被处理
        }
      } catch (handlerError) {
        console.error('Error handler failed:', handlerError);
        // 处理器出错，继续执行下一个
      }
    }
    return false; // 所有处理器都未处理该错误
  }

  /**
   * 清空所有处理器 - write by cursor
   */
  clear(): this {
    this.handlers = [];
    return this;
  }
} 